import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  isTVVersionActive: false
};

export default createReducer(initialState, {
  [c.TOGGLE_TV_VERSION]: (state, { payload }) => ({
    ...state,
    isTVVersionActive: payload.isActive
  })
});
